
<template>
    <div>
        <p>{{text}}</p>

        <div class="row">
            <div class="col-12">
                <h3 class="mt-4">{{ $t('textWithDatepicker.title') }} </h3>

                <input type="date" v-model="cptNextInspectionDate" />

                <label class="color-red" v-if="($store.getters.isOutOfTolerance || $store.getters.isOnEdge) && $store.getters.ultimatum < new Date(cptNextInspectionDate)">{{ $t('textWithDatepicker.lessYearWarning') }}</label>
            </div>
        </div>
    </div>
    
</template>

<script>
    import * as general from '@/scripts/General.js';

    export default {
        name: 'TextWithDatepicker',
        props: ['value', 'text'],
        data: function () {

            return {
                nextInspection: new Date(),
            }

        },
		beforeMount: function () {
			this.cptNextInspectionDate = this.$store.getters.ultimatum


		},
        mounted: function () {

        },
        methods: {

        },
		computed: {
			cptNextInspectionDate: {
				get: function () {
					return general.toHTML5date(this.nextInspection);
				},
				set: function (newContent) {
                    this.nextInspection = new Date(newContent).toISOString()
					this.$emit('input', this.nextInspection)
				}
			},
		},
        watch: {
            value: function (newValue) {
				this.nextInspection = new Date(newValue).toISOString()
            }
        },
       
    }
</script>
